var path = 'ng-table/filterRow.html';
var html = "<tr ng-show=show_filter class=ng-table-filters> <th data-title-text=\"{{$column.titleAlt(this) || $column.title(this)}}\" ng-repeat=\"$column in $columns\" ng-if=$column.show(this) class=\"filter {{$column.class(this)}}\" ng-class=\"params.settings().filterOptions.filterLayout === 'horizontal' ? 'filter-horizontal' : ''\"> <div ng-repeat=\"(name, filter) in $column.filter(this)\" ng-include=config.getTemplateUrl(filter) class=filter-cell ng-class=\"[getFilterCellCss($column.filter(this), params.settings().filterOptions.filterLayout), $last ? 'last' : '']\"> </div> </th> </tr> ";
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/browser/filterRow.html
// module id = 24
// module chunks = 0